import { useState } from 'react';
import { KmlStyleOptions, DEFAULT_KML_STYLE_OPTIONS } from '../utils/converters';

export function useConversionOptions() {
  const [options, setOptions] = useState<KmlStyleOptions>(DEFAULT_KML_STYLE_OPTIONS);
  const [isOpen, setIsOpen] = useState(false);

  function setOption<K extends keyof KmlStyleOptions>(key: K, value: KmlStyleOptions[K]) {
    setOptions(prev => ({ ...prev, [key]: value }));
  }

  function toggleOpen() {
    setIsOpen(prev => !prev);
  }

  return { options, setOption, isOpen, toggleOpen };
}
